import type { Namespace } from './namespaces';

/**
 * The languages the app can load. Add a language here (and a matching loader
 * below) when it ships — nothing else needs to change (GF-204).
 */
export const SUPPORTED_LANGUAGES = ['en', 'fr', 'es', 'it', 'pt'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export type LanguageResources = Record<Namespace, Record<string, unknown>>;

/**
 * One dynamic import per language, with LITERAL specifiers so both the bundler
 * (one `locale-<lng>` chunk each) and knip can resolve them statically. The
 * chunks are bundled with the app — no network — so they work offline on the
 * Capacitor build.
 */
export const LANGUAGE_LOADERS: Record<
  SupportedLanguage,
  () => Promise<{ default: LanguageResources }>
> = {
  en: () => import('./en'),
  fr: () => import('./fr'),
  es: () => import('./es'),
  it: () => import('./it'),
  pt: () => import('./pt'),
};
